import axios from 'axios';

import { API_URL_STELLAR_EXPERT } from 'constants/api';

import { getIsTestnetEnv } from 'helpers/env';

import type { ExpertAssetData } from 'types/api-stellar-expert';
import { Asset } from 'types/stellar';

import RequestCache from './request-cache';

const assetDetails = new RequestCache<ExpertAssetData[]>();

export const getAssetDetails = (asset: Asset): Promise<ExpertAssetData | undefined> => {
    const url = `${API_URL_STELLAR_EXPERT}explorer/${getIsTestnetEnv() ? 'testnet' : 'public'}/asset?search=${asset.issuer ?? 'XLM'}`;
    return assetDetails
        .get(url, () =>
            axios
                .get<{
                    _embedded: { records: ExpertAssetData[] };
                }>(url)
                .then(({ data }) => data._embedded.records),
        )
        .then(records =>
            records.find(details => {
                const [code, issuer] = details.asset.split('-');
                return code === asset.code && issuer === asset.issuer;
            }),
        );
};
